import axios from 'src/utils/axios';
export const DUPLICATE_CASE_OPEN = '@case/duplicate-case-open';
export const DUPLICATE_CASE_CLOSE = '@case/duplicate-case-close';
export const OPEN_CASE_SEARCH = '@case/open-case-search';
export const CLOSE_CASE_SEARCH = '@case/close-case-search';
export const CLEAR_CASE = '@case/clear-case';
export const GET_CASE_BANNER_INFORMATION = '@case/get-case-banner-information';
export const SET_CASE_JURISDICTION_ASSUMED =
  '@case/set-case-jurisdiction-assumed';
export const SET_CASE_ID = '@case/set-case-id';
export const OPEN_RECENT_CASES = '@case/open-recent-cases';
export const CLOSE_RECENT_CASES = '@case/close-recent-cases';

export function openCaseSearch() {
  return {
    type: OPEN_CASE_SEARCH,
  };
}

export function closeCaseSearch() {
  return {
    type: CLOSE_CASE_SEARCH,
  };
}

export function setCaseId(caseId) {
  return (dispatch) => {
    dispatch({
      type: SET_CASE_ID,
      payload: caseId,
    });
  };
}

export function clearCase() {
  return {
    type: CLEAR_CASE,
  };
}

export function closeDuplicateCaseWarning() {
  return {
    type: DUPLICATE_CASE_CLOSE,
  };
}

export function openDuplicateCaseWarning(duplicateCase) {
  return {
    type: DUPLICATE_CASE_OPEN,
    payload: duplicateCase,
  };
}

export function setCaseJurisdictionAssumed(jurisdictionAssumed) {
  return {
    type: SET_CASE_JURISDICTION_ASSUMED,
    payload: { jurisdictionAssumed },
  };
}

export function openRecentCases() {
  return {
    type: OPEN_RECENT_CASES,
  };
}
export function closeRecentCases() {
  return {
    type: CLOSE_RECENT_CASES,
  };
}
